import { useEffect, useState } from 'react';
import * as Sqrl from 'squirrelly';
import parse from 'html-react-parser';
import getParserOptions from '../options';
import LoadingSpinner from '../../../utils/LoadingSpinner';
import usePage from '../../../hooks/page';
import { consoleLog } from '../../../utils/Logger';
//import CompilationError from '../../500';
import { initFlowbite } from 'flowbite';

const AuthenticatedPublicPage = props => {
  const {
    siteMapPage,
    sequencer: { execute, run }
  } = props;

  const { page, html, data, ready } = usePage({
    siteMapPage,
    isPublicPage: true
  });

  if (data?.local?.logData) {
    console.log({ data });
  }

  const [parsedHtml, setParsedHtml] = useState();
  const [hasError, setHasError] = useState(false);

  consoleLog('AuthenticatedPublicPage', {
    name: page?.name,
    id: page?.id,
    data,
    ready
  });

  window.actionSequencer = {
    execute,
    run,
    page
  };

  useEffect(() => {
    if (ready) {
      let theHtml = html;
      try {
        theHtml = parse(
          Sqrl.render(html, data),
          getParserOptions({
            page,
            data
          })
        );
        setParsedHtml(theHtml);
      } catch (err) {
        setHasError(err);
        console.log('AuthenticatedPublicPage.error', {
          err,
          html: data?.local?.logData ? html : 'redacted'
        });
      }
    }
  }, [ready, page, data, html]);

  useEffect(() => {
    if (parsedHtml) {
      initFlowbite();
    }
  }, [parsedHtml]);

  if (!ready) {
    return <LoadingSpinner />;
  }

  if (hasError) {
    //return <CompilationError error={hasError} page={page} />;
  }

  return (
    <>
      {page?.css?.trim().length > 0 ? (
        <style type="text/css">{page.css}</style>
      ) : null}
      {parsedHtml}
    </>
  );
};

export default AuthenticatedPublicPage;
